<mat-dialog-content class="p-0 m-0 overflow-y-scroll">
    <form [formGroup]="cancellationForm" class="ml-1" *ngIf="!cancelled">
        <h1 class="text-xl md:text-2xl font-bold mb-4">Order Cancellation</h1>
        <p class="font-bold text-md mb-6 ">
            We're sorry to hear you're considering canceling your order. Before we proceed, is there anything we
            can do to improve your experience or address any concerns you might have?
        </p>

        <mat-form-field class="w-full rounded-2xl">
            <mat-label class="font-bold">Suggested Improvements</mat-label>
            <textarea id="name" class="text-xl" [formControlName]="'suggestedImprovements'" matInput></textarea>
        </mat-form-field>

        <mat-form-field class="w-full rounded-2xl">
            <mat-label class="font-bold">Reason for cancellation</mat-label>
            <mat-select matNativeControl [formControlName]="'reason'" (selectionChange)="reasonChange($event)">
                <mat-option *ngFor="let reason of cancellationReasonsList" [value]="reason">
                    {{reason?.Description}}
                </mat-option>
            </mat-select>
        </mat-form-field>

        <mat-form-field class="w-full rounded-2xl"
            *ngIf="requiresAdditionalInformation">
            <mat-label class="font-bold">Additional Information</mat-label>
            <textarea id="name" class="text-xl" [formControlName]="'additionalInformation'" matInput></textarea>
        </mat-form-field>

        <div class="flex flex-row justify-end ">
            <button class="mt-2 text-lg font-bold mx-4 bg-gray-100" mat-flat-button (click)="closeDialog()">
                Close
            </button>
            <button *ngIf="!cancelLoading" [disabled]="!cancellationForm.valid" class="mt-2 text-lg font-bold mx-4 bg-accent" mat-flat-button (click)="cancelOrder()">
                Proceed
            </button>
            <button *ngIf="cancelLoading" class="mt-2 text-lg font-bold mx-4 bg-accent" mat-flat-button>
                <mat-spinner class="h-5 w-5 white"></mat-spinner>
            </button>
        </div>
    </form>
    <div *ngIf="cancelled" class="flex flex-col items-center">
        <div class="self-start">
            <h1 class="text-xl md:text-2xl font-bold mb-4">Order Cancellation</h1>
            <p class="font-bold text-md mb-6">
                Success, your order has been cancelled!
            </p>
        </div>
        <button class="mt-2 text-lg font-bold mx-4 bg-accent w-1/3" mat-flat-button (click)="closeDialog()">
            Done
        </button>
    </div>
</mat-dialog-content>